// 新闻中心接口
import request from '@/utils/request'
export function getMenum(data) {
  return request({
    url: '/sm/column/getColumnListForFront',
    method: 'post',
    data: data
  })
}

// 内容列表-免登录
export function getBasicInfoByPageForFront(data) {
  return request({
    url: '/sm/basicInfo/getBasicInfoByPageForFront',
    method: 'post',
    data: data
  })
}

// 查询生产厂商
export function getManufacturer(data) {
  return request({
    url: `/sm/manufacturer/getManufacturerByPageForFront`,
    method: 'post',
    data: data
  })
}

// 生产厂商详情
export function getManufacturerDetailForFront(params) {
  return request({
    url: `/sm/manufacturer/detailForFront`,
    params: params,
    method: 'get'
  })
}

// 内容详情
export function getBasicInfo(id) {
  return request({
    url: `/sm/basicInfo/detailForFront?id=${id}`,
    method: 'get'
  })
}

// 查询产品信息
export function getProductList(data) {
  return request({
    url: `/sm/product/getProductByPageForFront`,
    method: 'post',
    data: data
  })
}


// 内容详情
export function getProCategory(type) {//type=proCategory
  return request({
    url: `/sm/config/getdictForFront?type=${type}`,
    method: 'get'
  })
}

// 获取生产商下的所有分类
export function getCompanyClassify(params) {
  return request({
    url: '/sm/classify/getListForFront',
    method: 'get',
    params: params
  });
}



// WEBPACK FOOTER //
// ./src/api/sm/news.js